<template>
  <v-dialog v-model="showing" max-width="550px">
    <v-card>
      <v-card-title>
        Transaction note
      </v-card-title>
      <v-card-text>
        <div class="font-weight-bold">Internal note</div>
        <div>{{ transaction.internal_note ? transaction.internal_note : '-' }}</div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="showing = false">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      required: true
    },
    transaction: {
      required: true
    }
  },
  computed: {
    showing: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
  },
};
</script>
